<div class="wrap-p-dialog">
    <p-dialog [(visible)]="isVisible" [styleClass]="'modifier-category'">
        <ng-template pTemplate="header">{{
            'IRONSIDE.product-catalog-dialog.EDIT_CATALOG' | translate
        }}</ng-template>
        <div class="inner-cnt">
            <div class="content-catalogue d-flex justify-content-between flex-wrap">
                <div *ngFor="let category of categories" class="catalogue-item">
                    <h3>
                        <input
                            type="checkbox"
                            [id]="category.id"
                            [(ngModel)]="category.selected"
                            (change)="onChange(category)"
                        />
                        <a> {{ category?.nameCategory | translateDynamicLanguage }}</a>
                    </h3>
                    <div class="catalogue-body">
                        <ul>
                            <li *ngFor="let category2 of category.subcategoryList">
                                <div class="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        class="me-1"
                                        [id]="category2.id"
                                        [(ngModel)]="category2.selected"
                                        (change)="onChange(category2, category)"
                                    />
                                    <a> {{ category2.nameCategory | translateDynamicLanguage }}</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="d-flex justify-content-between">
                <button class="btn-custom ANNULER" mat-dialog-close="">
                    {{ 'IRONSIDE.product-catalog-dialog.CANCEL' | translate }}
                </button>
                <button class="btn-common" (click)="submit()">
                    {{ 'IRONSIDE.product-catalog-dialog.VALIDATE' | translate }}
                </button>
            </div>
        </ng-template>
    </p-dialog>
</div>
